<template>
  <div class="special-item">
    <YorkbbsImage class="special-cover" animation :src="coverImage" :link="detailURL"> </YorkbbsImage>

    <div class="special-right">
      <div class="special-title e-2">
        <a :href="detailURL">{{ title }}</a>
      </div>
      <div class="special-subtitle e-2">{{ shortDescription }}</div>
    </div>
  </div>
</template>
<script>
import { hostBuild } from '@/utils/utils';
export default {
  name: 'ItemSpecial',
  props: { data: Object },
  computed: {
    title() {
      return this.data.property.title || this.data.title;
    },
    shortDescription() {
      return this.data.property.shortDescription;
    },
    coverImage() {
      return this.data.property.coverImage[0];
    },
    cmsType() {
      return this.data.property.cmsType;
    },
    detailURL() {
      //return hostBuild(`/special/${this.topicType == 1 ? 'big' : 'small'}/${this.data.id}`, 'info');
      if (this.data.property.jumpLink) {
        return this.data.property.jumpLink;
      } else if (this.cmsType === 3) {
        return hostBuild(`/special/${this.topicType == 1 ? 'big' : 'small'}/${this.data.id}`, 'info');
      } else if(this.cmsType == 6 ){
        return hostBuild(`/specials/subject/${this.data.id}`,'news') ;
      }else if ([2, 4].includes(this.cmsType)) {
        return hostBuild(`/feature/${this.topic.englishName}/${this.data.id}`,'news');
      }
      return  '#';
      //return hostBuild(`/detail/${this.topic.englishName}/${this.data.id}`,'news');
    },
  },
};
</script>
<style lang="scss" scoped>
.special-item {
  display: flex;
  justify-content: space-between;
}

.special-cover {
  width: 160px;
  height: 120px;
  border-radius: 4px;
  border: 1px solid #eee;
}

.special-right {
  flex: 1;
  width: 0;
  padding-left: 15px;
  padding-right: 60px;
}

.special-title {
  font-size: 16px;
  font-weight: 500;
  color: var(--text-color-3);
  line-height: 24px;
  margin-bottom: 10px;
  a {
    &:hover {
      color: var(--primary-color);
    }
  }
}

.special-subtitle {
  font-size: 14px;
  color: var(--text-color-9);
  line-height: 20px;
}
</style>
